import type { CellContext, ColumnDef } from "@tanstack/react-table";
import type { ParticipantRow } from "./types";
import { SectionAvailability } from "../types";

export const MANAGING_SECTION_COLUMN_HEADER = "Managing Section";
export const MANAGING_SECTION_EXPORT_HEADER = MANAGING_SECTION_COLUMN_HEADER;

export function getManagingSectionParticipantColumn(): ColumnDef<ParticipantRow, unknown> {
  return {
    accessorKey: "managingSectionName",
    header: MANAGING_SECTION_COLUMN_HEADER,
    cell: ({ row }: CellContext<ParticipantRow, unknown>) => row.original.managingSectionName ?? "—",
    enableSorting: false,
    size: 200
  };
}

export function appendManagingSectionColumn(
  columns: ColumnDef<ParticipantRow, unknown>[],
  sectionAvailability?: SectionAvailability
): ColumnDef<ParticipantRow, unknown>[] {
  if (sectionAvailability !== SectionAvailability.CAN_CREATE) {
    return columns;
  }

  return [...columns, getManagingSectionParticipantColumn()];
}

export function getManagingSectionExportValue(participant: ParticipantRow): string {
  return participant.managingSectionName ?? "—";
}
